import { render, staticRenderFns } from "./BulkJobList.vue?vue&type=template&id=63d438c9"
import script from "./BulkJobList.vue?vue&type=script&lang=js"
export * from "./BulkJobList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports